<div class="ui-g ui-fluid form-group master-data customer-cards-info" *ngIf="labels && formData">
  <p-panel *ngFor="let customerCluster of clusters; index as i" class="ui-g-12 ui-md-12">
    <p-header>
      <div class="ui-helper-clearfix">
        <span class="ui-panel-title">{{ customerCluster.clusterDescription + ' (' +
          customerCluster.clusterTypeDescription + ')' }}</span>

        <span class="ui-button-title" style="margin-left: 20px;"
          [hidden]="mgCustomerPermission && customerCluster.code === '0'">
          <button *ngIf="customerCluster.editableCluster"  pButton type="button" class="ui-button-danger btnDelete" icon="fa fa-close"
            (click)="openDeleteClusterModal(customerCluster)" pTooltip="{{ labels.removeClusterHeader }}"></button>
        </span>

        <span class="ui-button-title" [hidden]="mgCustomerPermission && customerCluster.code === '0'">
          <button *ngIf="customerCluster.editableCluster" pButton type="button" class="ui-button-info btnEdit" icon="fa fa-pencil"
            (click)="openEditClusterModal(customerCluster, i)" pTooltip="{{ labels.editClusterHeader }}"></button>
        </span>

      </div>
    </p-header>

    <div class="ui-g-12 ui-fluid">
      <div class="ui-g-3">
        <label>{{ labels.headDescription }}</label>
        <span>{{customerCluster.code}} - {{ customerCluster.headDescription }}</span>
      </div>
      <div class="ui-g-3">
        <label>{{ labels.validity }}</label>
        <span>{{ customerCluster.date_start | date:'dd/MM/yyyy' }} - {{ customerCluster.date_end | date:'dd/MM/yyyy'
          }}</span>
      </div>
      <!-- nascosto campo deploy come da issue KS-6377
      <div class="ui-g-3" *ngIf="!mgCustomerPermission">
        <label>Deploy</label>
        <span [style.color]="customerCluster.flgDeployed == 0 ? 'green': 'red'">{{ customerCluster.flgDeployed }}</span>
      </div>
      -->
      <div class="ui-g-3" *ngIf="customerCluster.flgDeployed && !mgCustomerPermission">
        <p-accordion>
          <p-accordionTab [header]="labels.conversionCode">
            <ul class="list-unstyled">
              <li>
                {{ customerCluster.conversionCode }} ({{ customerCluster.ochannelDescription }})
              </li>
            </ul>
          </p-accordionTab>
        </p-accordion>
      </div>
    </div>
  </p-panel>
  <div class="clearfix"></div>

  <p-panel class="ui-g-12 ui-md-12">
    <p-header>

      <div class="ui-helper-clearfix">
        <span class="ui-panel-title">{{ labels.addClusterHeader }}</span>
      </div>

    </p-header>

    <div class="ui-g-12 ui-fluid">
      <div class="ui-g-12">
        <span>{{ labels.addClusterDescription }}</span>
        <br><br />
        <button pButton type="button"  class="ui-button-success btnDelete" icon="fa fa-plus"
          pTooltip="{{ ((mgCustomerPermission &&  isClusterAdd) || !mgCustomerPermission) ? labels.addClusterHeader : labels.selectCardCustomer }}"
          (click)="openAddClusterModal()" >
        </button>
      </div>
    </div>
  </p-panel>


  <div class="clearfix"></div>


  <!-- ADD CLUSTER -->
  <p-dialog header="{{ labels.addClusterHeader }}" *ngIf="showAddClusterModal" [(visible)]="showAddClusterModal" [modal]="true" [draggable]="false"
    [resizable]="false" (onHide)="closeAddCluster()">
    <div class="ui-dialog-content">

      <div class="ui-g">
        <div class="ui-g-12 ui-md-12">
          <span class="label">{{ labels.selectCluster }}</span>
          <p-autoComplete #clusterDropdown data-testid="clusterDropdown" [(ngModel)]="clusterAutocomplete" [suggestions]="clustersAvailable"
            (completeMethod)="filterClusterSingle($event)" (onSelect)="clusterSelected($event, endDateRef)" placeholder="Select..."
            [minLength]="2" field="headDescription" [dropdown]="true" required="true">
            <ng-template let-customerCluster pTemplate="item">
              <div class="ui-helper-clearfix" style="border-bottom:1px solid #D5D5D5">
                <div>{{ customerCluster.headDescription }} - {{ customerCluster.date_start }} / {{ customerCluster.date_end }}
                  <span *ngIf="customerCluster.code; else noCC">(CODE: {{ customerCluster.code
                    }})</span>
                  <ng-template #noCC>
                    (NO CC)
                  </ng-template>
                </div>
              </div>
            </ng-template>
          </p-autoComplete>
        </div>
      </div>
<div class="ui-g">
  <!-- Data inizio -->
  <div class="ui-g-12 ui-md-6">
    <span class="label">{{ labels.date_start }}</span>
    <app-kv-calendar
      #startDateRef
      data-testid="startDateRef"
      [inputName]="'startDate'"
      [formData]="formData"
      [startDateSelector]="true"
      [endDateInputName]="'endDate'"
      [minDate]="formData.get('startDate').value || today"
      [endDateCalendar]="endDateRef"
      [defaultDate]="setDefaultDateStart()"
      [defaultValue]="setDefaultDateStart()">
    </app-kv-calendar>
  </div>

  <!-- Data fine -->
  <div class="ui-g-12 ui-md-6">
    <span class="label">{{ labels.date_end }}</span>
    <app-kv-calendar
      #endDateRef
      data-testid="endDateRef"
      [inputName]="'endDate'"
      [formData]="formData"
      [endDateSelector]="true"
      [startDateInputName]="'startDate'"
      [minDate]="formData.get('startDate').value || today"
      [startDateCalendar]="startDateRef"
      [defaultDate]="formData.get('startDate').value || today"
      [defaultValue]="setDefaultDateEnd(endDateRef)">
    </app-kv-calendar>
  </div>
</div>

      <div class="ui-g">
        <div class="ui-g-12">
          <span [hidden]="!addClusterDateRangeError" style="color: #F00000">{{ labels.addClusterDateRangeError }}</span>
        </div>
      </div>

    </div>

    <div class="ui-dialog-footer">
      <button type="button" pButton class="ui-button-success btnDelete" icon="fa fa-plus" iconPos="left"
        (click)="addCustomerCluster()" label="{{ labels.add }}"></button>
      <button type="button" pButton class="ui-button-danger btnDelete" icon="fa fa-close" iconPos="left"
        (click)="closeAddCluster()" label="{{ labels.cancel }}"></button>
    </div>
  </p-dialog>


  <!-- EDIT CLUSTER -->
  <p-dialog header="{{ labels.editClusterHeader }}" *ngIf="showEditClusterModal" [(visible)]="showEditClusterModal" [modal]="true"
    [draggable]="false" [resizable]="false">
    <div class="ui-dialog-content">

      <div class="ui-g">
        <div class="ui-g-12 ui-md-3">
          <span class="label">{{ labels.date_start }}</span>
          <app-kv-calendar #startDateEditRef data-testid="startDateEditRef" [inputName]="'startDate'" [formData]="formData" [startDateSelector]="true"
            [endDateInputName]="'endDate'" [minDate]="formData.get('startDate').value || today"
            [endDateCalendar]="endDateEditRef" [defaultDate]="setDefaultDateStart()" [defaultValue]="setDefaultDateStart()">
          </app-kv-calendar>
        </div>

        <div class="ui-g-12 ui-md-3">
          <span class="label">{{ labels.date_end }}</span>
          <app-kv-calendar #endDateEditRef data-testid="endDateEditRef" [inputName]="'endDate'" [formData]="formData" [endDateSelector]="true"
            [startDateInputName]="'startDate'" [minDate]="today" [startDateCalendar]="startDateEditRef"
            [defaultDate]="setDefaultDateEnd()" [defaultValue]="setDefaultDateEnd()">
          </app-kv-calendar>
        </div>
      </div>

      <div class="ui-g">
        <div class="ui-g-12">
          <span [hidden]="!addClusterDateRangeError" style="color: #F00000">{{ labels.addClusterDateRangeError }}</span>
        </div>
      </div>
      <br />
      <div class="ui-g wanrningEdit" *ngIf="showWarningEdit">
        <div class="ui-g-12">
          <p>{{ 'customerCluster.warning_1' | translate }}</p>
          <p>{{ 'customerCluster.warning_edit' | translate }}</p>
          <p>{{ 'customerCluster.warning_2' | translate }}</p>

        </div>
      </div>
    </div>

    <div class="ui-dialog-footer">
      <button type="button" pButton class="ui-button-success btnEdit" icon="fa fa-pencil" iconPos="left"
        *ngIf="showWarningEdit" (click)="onClickConfirmEdit()" label="{{ labels.yes }}"></button>
      <button type="button" pButton class="ui-button-danger btnDelete" icon="fa fa-close" iconPos="left"
        *ngIf="showWarningEdit" (click)="showWarningEdit = false;" label="NO"></button>

      <button type="button" pButton class="ui-button-success btnEdit" icon="fa fa-pencil" iconPos="left"
        *ngIf="!showWarningEdit" (click)="editCustomerCluster()" label="{{ labels.save }}"></button>
      <button type="button" pButton class="ui-button-danger btnDelete" icon="fa fa-close" iconPos="left"
        *ngIf="!showWarningEdit" (click)="showEditClusterModal = false;" label="{{ labels.cancel }}"></button>
    </div>
  </p-dialog>


  <!-- DELETE CLUSTER -->
  <p-dialog header="{{ labels.removeClusterHeader }}" [(visible)]="showDeleteClusterModal" [modal]="true"
    [draggable]="false" [resizable]="false">
    <div class="ui-dialog-content">
      <div class="ui-g">
        <div class="ui-g-12 ui-md-12">
          <span class="label">{{ 'customerCluster.removeClusterDescription' | translate }}</span>
        </div>
      </div>
      <br />
      <div class="ui-g wanrningEdit">
        <div class="ui-g-12">
          <p>{{ 'customerCluster.warning_1' | translate }}</p>
          <p>{{ 'customerCluster.warning_del' | translate }}</p>
          <p>{{ 'customerCluster.warning_2' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="ui-dialog-footer" *ngIf="showDeleteClusterModal">
      <button type="button" pButton class="ui-button-success btnDelete" icon="fa fa-ban"
        (click)="deleteCustomerCluster()" label="{{labels.yes}}"></button>
      <button type="button" pButton class="ui-button-danger btnDelete" icon="fa fa-close"
        (click)="showDeleteClusterModal = false" label="'NO'"></button>
    </div>
  </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-clusters/customer-clusters.component.html